/**
 * The inspector puts a day's route in order (JIM-1006-04b, Jim 2026-10-06):
 * a row moves one step up or down; the whole day's ids are then saved as the
 * route order the plan reads first. Pure, so the page can show the move at
 * once and the test can check it without a browser.
 */
export function moveWithin<T extends { inspection_id: string }>(
  rows: T[],
  inspectionId: string,
  direction: 'up' | 'down'
): T[] {
  const from = rows.findIndex((r) => r.inspection_id === inspectionId);
  const to = direction === 'up' ? from - 1 : from + 1;
  if (from < 0 || to < 0 || to >= rows.length) return rows;
  const next = rows.slice();
  [next[from], next[to]] = [next[to], next[from]];
  return next;
}
